import Application from './Application';
import { workPool } from '@wochitnpm/helpers';

const app = new Application({
  /**
   * no user interaction beyond this point
   */
  stop: function () {
    this.lockInteraction();
    app.state.enableNavigation();
    app.keyboardAccessibility.off();
    Backbone.history.stop();
    workPool.destroy();

    // TODO: stop all ongoing ajax requests, timeouts, intervals
  },

  lockInteraction: function () {
    $('body').css({ 'pointer-events': 'none' });
  },

  unlockInteraction: function () {
    $('body').css({ 'pointer-events': 'all' });
  },

  navigate: function (route, options) {
    options = $.extend(
      {
        // trigger change route event
        trigger: true,
        // alter navigation history:
        // true - replace current url with new one
        // false - add new url, old one is still navigable
        replace: true,
        closeModals: true,
      },
      options
    );
    Backbone.history.navigate(route, options);

    if (options.closeModals) {
      app.closeModals();
    }
  },

  navigateWochitInsideIndividuals() {
    // if (document.referrer && document.referrer !== window.location) {
    //   window.location = document.referrer;
    // } else if (tk.context.siteDomainUrl) {
    //   window.location = tk.context.siteDomainUrl;
    // } else {
    //   window.location = 'https://wochit.com';
    // }
    window.location = 'https://wochit.com';
  },

  navigate2Shortcut: function (o) {
    const channelId = serverProfile.channelId ?? app.DEFAULT.CHANNEL_ID;
    o = _.options(o, {
      route: '',
      params: {
        channelId,
      },
    });
    let url = `${serverProfile.shortcutSdkUrl}/${o.route}`;
    const urlParams = $.param(o.params);
    if (urlParams) {
      url += `?${urlParams}`;
    }
    window.location = url;
  },

  /**
   * Open support page in another tab
   * @param [o] {object}
   * @param [o.path]
   * @param [o.params] {object}
   * @return {Window}
   */
  openSupportTab: function (o) {
    const channelId = serverProfile.channelId ?? app.DEFAULT.CHANNEL_ID;
    o = _.merge(
      {
        path: '',
        params: {
          channelId: channelId === app.DEFAULT.CHANNEL_ID ? null : channelId,
        },
      },
      o
    );
    const isProd = app.rootStore.getters['user/box'].isProd();
    let url = `https://${isProd ? 'www' : 'wp-dev'}.wochit.com/support`;
    if (o.path) {
      url += `/${o.path}`;
    }

    const urlParams = $.param(_.compactObject(o.params));
    if (urlParams) {
      url += `?${urlParams}`;
    }

    return window.open(url, '_blank');
  },

  navigate2Login: function (options) {
    options = _.options(options, {
      redirectUrl: null,
      allowGetBack: false,
    });

    // default from serverProfile
    let domain = serverProfile.loginUrl;

    if (tk.channelId) {
      domain = '/login';
    } else if (options.redirectUrl) {
      domain = options.redirectUrl;
    }

    const curLocation = window.location.href;
    const isStoryUrl = /\/stories\//i.test(curLocation);
    if (options.allowGetBack && !isStoryUrl) {
      domain += `${
        /\?/.test(domain) ? '&' : '?'
      }redirectUrl=${window.encodeURIComponent(curLocation)}`;
    }

    window.location = domain;
  },

  /**
   * Navigate to dashboard
   * @param [options]  navigation options
   */
  navigateToDashboard: function (options) {
    if (app.isEmbedded) {
      app.navigate2Shortcut({ route: 'dashboard' });
      return;
    }

    options = $.extend(
      {
        recentTab: true,
      },
      options
    );

    let path = 'dashboard/home';

    if (options.recentTab && app.rootStore.state.backNavigablePath) {
      path = app.rootStore.state.backNavigablePath;
    }
    app.navigate(path, options);
  },

  sudo: {
    autosave: {
      on: function () {
        this.override = true;
        this.enabled = true;
      },
      off: function () {
        this.override = true;
        this.enabled = false;
      },
      override: false,
      enabled: true,
      failure: false,
    },
    timeline: {
      reset() {
        const story = app.storyController.story;
        if (!story) {
          return;
        }
        const $timeline = $('.layer-container');
        const timeline =
          $timeline.length &&
          ($timeline.data('wochit-wtTimelineTimebase') ||
            $timeline.data('wochit-wtTimelineTextbase'));
        if (!timeline) {
          return;
        }

        const assets = timeline.getAssets({
          includeNovoAsset: true,
          excludeSotPlaceholder: true,
        });
        _.each(assets, (asset, i) => {
          const skipHistory = i < assets.length - 1;
          if (timeline.is.novoAsset(asset.$el)) {
            timeline.removeNovoAsset({ asset: asset, skipHistory });
          } else {
            timeline.removeAsset({
              asset: asset,
              rearrange: true,
              skipHistory,
            });
          }
        });
      },
    },
  },
});

window.app = app;

export default app;
